module.exports = __webpack_public_path__ + "static/media/brand23.27bee2ad.png";